module.exports = __webpack_public_path__ + "img/pay_card1.0801caeb.svg";